import React from 'react';
import { motion } from 'framer-motion';
import FloatingElements from './FloatingElements';
import { taglineVariants } from './animations';

/** Background image bundled from the public directory */
const BACKGROUND_IMAGE_URL = `${process.env.PUBLIC_URL}/LoginImage2.png`;

/**
 * LoginLeftPanel Component
 * 
 * Left side panel of the login page containing:
 * - Background image with overlay
 * - Animated floating geometric elements
 * - Company tagline
 * 
 * Only visible on large screens (lg: and up).
 * Hidden on mobile for better UX.
 * 
 * @example
 * <LoginLeftPanel />
 */
const LoginLeftPanel: React.FC = () => {
  return (
    <div
      className="hidden lg:flex lg:w-1/2 relative overflow-hidden"
      aria-hidden="true" // Decorative, not essential for screen readers
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BACKGROUND_IMAGE_URL})` }}
      />

      {/* Dark Overlay with Red Tint */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/75 to-haat-red/30" />

      {/* Floating Geometric Elements */}
      <FloatingElements />

      {/* Tagline Card */}
      <motion.div
        variants={taglineVariants}
        initial="initial"
        animate="animate"
        className="absolute bottom-16 left-8 right-8 z-20"
      >
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
          <h2 className="text-white text-2xl font-rubik font-bold mb-2">
            Powering HAAT's Internal Tools
          </h2>
          <p className="text-white/70 font-inter">
            One portal. All applications. Complete control.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginLeftPanel;

